import React, { useEffect, useState } from "react";
import styles from "./portalApp.module.css";
import profileImg from "./images/graduation.jpg";
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import Marksheet from "./Marksheet";
import { useNavigate,Link } from "react-router-dom";
import Header from "./header";
import MyFooter from "./my footer";
import { act } from "react";
import axios from "axios";
import ModalForm from "../../components/ModalForm";

const PortalApp = () => {
  const navigate = useNavigate();
  const [myProfile, setMyProfile] = useState([]);
  const [showProfile, setShowProfile] = useState(true);
  const token = getToken();
  const std_id = decodeToken(token, "id");

  const [tabData, setTabData] = useState({ Lessons: [],
    Examination: [],
    Results: [],
    Marksheet: [],});

  const [activeTab, setActiveTab] = useState("Lessons");

  const [allowedTabs, setAllowedTabs] = useState([]);
  const [studentBalance,setStudentBalance]=useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRoute, setCurrentRoute] = useState(null);
  const [queryParams,setqueryParams]=useState([]);

   const openModal2 = (route,queryParams) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
    setqueryParams(queryParams)
  };

  const closeModal = () => {
    setIsModalOpen(false);
  
  };




  useEffect(() => {
  const loadStudentData = async () => {
    if (!std_id) return; // ensure student ID exists

    try {
      // 1️⃣ Fetch tabs
      const tabsUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/Web-Tab`;
      const tabsResponse = await postData(tabsUrl, { student_id: std_id });
      const allowed = Array.isArray(tabsResponse?.data)
        ? tabsResponse.data.map((item) => item.tab)
        : [];
      setAllowedTabs(allowed);
      console.log("Allowed Tabs:", allowed);

      // 2️⃣ Fetch student profile
      const profileUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-myProfile`;
      const profileResponse = await postData(profileUrl, { std_id });
      console.log('student profile',profileResponse)
      setMyProfile(profileResponse.data);

      // 3️⃣ Fetch balance
      const balResponse = await axios.post("https://ecampus.uniso.edu.so/api/report", {
        sp: 700,
        std_id,
      });
      const bal = balResponse.data.result?.[0]?.balance ?? 0;
      setStudentBalance(bal);
      console.log("Student Balance:", bal);

      // 4️⃣ Conditional data fetching after balance is known
      if (allowed.includes("Lessons")) {
        await getData();
      }

      if (allowed.includes("Examination")) {
        await getExam();
      }

      if (allowed.includes("Results") ) {
        await getResult();
      }
    } catch (error) {
      console.error("Error loading student data:", error);
    }
  };

  const getData = async () => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/getCourse`;
    const response = await postData(url, { std_id });
    const lessonsData = response.data.map((item, index) => ({
      No: index + 1,
      ...item,
    }));
    setTabData((prev) => ({ ...prev, Lessons: lessonsData }));
  };

  const getExam = async () => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/ExamTime`;
    const response = await postData(url, { std_id });
    const examData = response.data.map((item, index) => ({
      No: index + 1,
      ...item,
    }));
    setTabData((prev) => ({ ...prev, Examination: examData }));
  };

  const getResult = async () => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-result`;
    const response = await postData(url, { std_id });
    const resultData = response.data.map((item, index) => ({
      No: index + 1,
      ...item,
    }));
    setTabData((prev) => ({ ...prev, Results: resultData }));
  };

  loadStudentData();
}, [std_id]);

 







  // for consoling data only
   useEffect(()=>{
      console.log('currentData:',tabData[activeTab])
    },[tabData])

 const handleEnterExam = (item, student_type) => {
  if (!student_type) {
    console.warn("⚠️ student_type missing:", item);
    return;
  }

  console.log("type:", student_type);

  navigate("/questions", {
    state: {
      student_id: std_id,
      class_id: item["class_id~hide"],
      semester_id: item["semester_id~hide"],
      course_id: item["course_id~hide"],
      exam_type: item["exam_type~hide"],
      id: item["id~hide"],
      student_type: student_type,
    },
  });
};


  const currentData = tabData[activeTab] || [];

  return (
    <>
      <Header></Header>
      <div className={styles.container}>
        <h1 className={styles.header}>Profile & {activeTab}</h1>

        {/* ✅ Show/Hide Profile Button */}
        <button
          className={styles.toggleBtn}
          onClick={() => setShowProfile(!showProfile)}
        >
          {showProfile ? "Hide Profile" : "Show Profile"}
        </button>

        <div className={styles.content}>
          {/* ✅ Profile Section */}
          <div
            className={`${styles.profile} ${
              showProfile ? styles.showProfile : styles.hideProfile
            }`}
          >
            <h3>My Profile</h3>
            <img
              src={
               
                   `${'https://ecampus.uniso.edu.so'}/${myProfile[0]?.Image}`
                  
              }
              alt="Profile"
              className={styles.profileImg}
            />
            <p>
              <strong>Name:</strong> {myProfile[0]?.["Name"]}
            </p>
            <p>
              <strong>Student ID:</strong> {myProfile[0]?.["Student ID"]}
            </p>
            <p>
              <strong>Program:</strong> {myProfile[0]?.["Program"]}
            </p>
            <p>
              <strong>Class:</strong> {myProfile[0]?.["Class"]}
            </p>
            <p>
              <strong>Semester:</strong> {myProfile[0]?.["Semester"]}
            </p>
            <p>
              <strong>Balance:</strong> <span style={{fontSize:'20px',color:'red'}}>${studentBalance}.00</span>
            </p>
   {
    studentBalance >0&&(
      <div className="mt-3" >

  {/* Salam Bank */}
  <p>
    <a
    href={`tel:*799*30006390*${studentBalance}#`}
    className="btn btn-danger w-80 mb-2 "
    style={{fontSize:'20px'}}


    
  >
    Salam Bank: *799*30006390*lacagta#
  </a>
  </p>

  {/* Dahabshiil */}
  <p>
    <a
    href={`tel:*799*2146*${studentBalance}#`}
    className="btn btn-danger w-80"
     style={{fontSize:'20px'}}
  >
    Dahabshiil: *799*2146*lacagta#
  </a>
  </p>
    {
  myProfile[0] &&
 (!myProfile[0].email ||
  !myProfile[0].country  ||
  !myProfile[0].city ) && (
     <button className="btn btn-primary"
     onClick={()=>openModal2('Complete-Profile',`student_id=${std_id}`)}
     > Complete Your Profile</button>
  )
    }
</div>
    )
   }

          </div>

          {/* ✅ Tabs and Table */}
          <div className={styles.courses}>
            <div className={styles.tabs}>
              {Object.keys(tabData).map((tab) => (
                <button
                  key={tab}
                  className={`${styles.tabBtn} ${
                    activeTab === tab ? styles.active : ""
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            <h4>{`My ${activeTab}`}</h4>

            {activeTab === "Marksheet" && allowedTabs.includes('Marksheet')  
             ? (
              <Marksheet studentId={std_id} />
            ) : currentData.length > 0 ? (
              <div className={styles.tableWrapper}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      {Object.keys(currentData[0])
                        .filter((key) => !key.includes("~hide"))
                        .map((key) => (
                          <th key={key}>{key}</th>
                        ))}
                    </tr>
                  </thead>
        <tbody>
  {currentData.map((item, index) => (
    <tr key={index}>
      {Object.keys(item)
        .filter((key) => !key.includes("~hide"))
        .map((key) => (
          <td key={key}>
            {key === "COURSE" ? (
              <Link
                to={`/coursedetails/${item["course_id~hide"]}`}
                state={{
                  course_id: item["course_id~hide"],
                  class_id: item["class_id~hide"],
                  semester_id: item["semester_id~hide"],
                  student_id: std_id,
                }}
                style={{
                  textDecoration: "none",
                  color: "blue",
                }}
              >
                {item[key]}
              </Link>
            ) : key === "Book" ? (
              item[key] ? (
                <a
                  href={`${API_URL}/${item[key].replace("public", "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "green",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  View Document
                </a>
              ) : (
                <span style={{ color: "gray" }}></span>
              )
            ) : item[key] === "ontime" ? (
              <button
                onClick={  () => handleEnterExam(item,item["type~hide"])}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Start Exam
              </button>
            ) : (
              item[key]
            )}
          </td>
        ))}
    </tr>
  ))}
</tbody>





                </table>
              </div> 
             
      
            ) : (allowedTabs.includes(activeTab)  ? 
              
              (<p>No data available for {activeTab}.</p>):
               
              (<p>Qeybta Admin-ka la xiriir Fadlan.</p>)
            )}
          </div>
        </div>
      </div>
      <MyFooter />
       {isModalOpen &&
        currentRoute &&
 
      (<ModalForm
              userId={std_id}
              token={token}
              route={currentRoute} // Pass the dynamic route to the modal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
              queryParams={queryParams}
            />)
      }
      
    </>

    
  );
};

export default PortalApp;
